/**
 * PipelineIntelligenceCockpit — Cockpit-language frame for /pipeline-intelligence.
 */
import { useMemo } from "react";
import {
  CockpitPage, CockpitMasthead, HeroMetric, HeroDivider, CockpitKpiStrip,
} from "@/components/cockpit/CockpitShell";
import { useAppData } from "@/data/AppDataContext";
import PipelineIntelligence from "./PipelineIntelligence";

export default function PipelineIntelligenceCockpit() {
  const { salesOpportunities } = useAppData();

  const kpis = useMemo(() => {
    const open = salesOpportunities.filter((o) => o.stage !== "Closed Won" && o.stage !== "Closed Lost");
    const won = salesOpportunities.filter((o) => o.stage === "Closed Won");
    const pipelineValue = open.reduce((s, o) => s + (o.totalEstimate || 0), 0);
    const wonValue = won.reduce((s, o) => s + (o.totalEstimate || 0), 0);
    return { open: open.length, won: won.length, pipelineValue, wonValue };
  }, [salesOpportunities]);

  return (
    <CockpitPage>
      <CockpitMasthead
        eyebrow="Automations & Intelligence · Revenue"
        title="Revenue Command Center"
        right={
          <>
             <HeroMetric label="Pipeline" value={`$${((kpis.pipelineValue) / 1000).toLocaleString(undefined, {maximumFractionDigits: 0})}K`} hero />

            <HeroDivider />
            <HeroMetric label="Won" value={`$${(kpis.wonValue / 1000).toFixed(0)}K`} tone="good" />
            <HeroDivider />
            <HeroMetric label="Open Opps" value={kpis.open} />
          </>
        }
      />
      <CockpitKpiStrip
        items={[
          { label: "Open Opportunities", value: kpis.open },
          { label: "Closed Won", value: kpis.won, tone: "good" },
           { label: "Pipeline Value", value: `$${((kpis.pipelineValue) / 1000).toLocaleString(undefined, {maximumFractionDigits: 0})}K` },

          { label: "Won Revenue", value: `$${(kpis.wonValue / 1000).toFixed(0)}K`, tone: "good" },
        ]}
      />
      <div className="cockpit-surface">
        <PipelineIntelligence />
      </div>
    </CockpitPage>
  );
}
